import { Badge, Button, ButtonProps } from "@chakra-ui/react";
import { MdFilterList } from "react-icons/md";
import { TriangleDownIcon } from "@chakra-ui/icons";
import { formatInteger } from "utils/formatting";

type Props = ButtonProps & {
  isDirty?: boolean;
  isOpen?: boolean;
  isValid?: boolean;
  numFilters?: number | null;
};

export default function ToggleFiltersButton({
  isDirty,
  isOpen,
  isValid = true,
  numFilters,
  ...rest
}: Props) {
  return (
    <Button
      leftIcon={<MdFilterList />}
      rightIcon={
        <TriangleDownIcon
          fontSize=".65em"
          transform="rotate(-90deg)"
          transition="250ms transform"
          sx={{ "[aria-expanded=true] &": { transform: "rotate(0)" } }}
        />
      }
      size="xs"
      variant="ghost"
      textTransform="none"
      aria-expanded={isOpen}
      {...rest}
    >
      Filters{" "}
      {numFilters ? (
        <Badge
          ml={1}
          colorScheme={
            (isValid && isDirty && "green") ||
            (isValid && "pinkButton") ||
            (!isValid && "red") ||
            undefined
          }
          fontFamily="body"
          variant="solid"
        >
          {formatInteger(numFilters)}
        </Badge>
      ) : null}
    </Button>
  );
}
